import { memo } from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const EllipseRenderer = ({ ellipse, onClick, path, style, sx }) => {
    const rotation = (ellipse.rotation * 180) / Math.PI
    return (
        ellipse && (
            <Box
                component="ellipse"
                cx={ellipse.centrePoint.x}
                cy={ellipse.centrePoint.y}
                id={path.pathId}
                rx={ellipse.radiusX}
                ry={ellipse.radiusY}
                style={style}
                sx={sx}
                transform={`rotate(${rotation}, ${ellipse.centrePoint.x}, ${ellipse.centrePoint.y})`}
                onClick={onClick}
            />
        )
    )
}

EllipseRenderer.propTypes = {
    ellipse: PropTypes.object,
    path: PropTypes.object,
    style: PropTypes.object,
    sx: PropTypes.object,
    onClick: PropTypes.func,
}

export default memo(EllipseRenderer)
